// Limits of the tariff plan (core GET /users/me/plan) and the messages found this month (data
// GET /usage/findings): the profile and the warnings on the messages page.
import apiClient from '@/apiClient'
import apiDataClient from '@/apiDataClient'

export const WARN_SHARE = 0.9

export async function loadPlanUsage() {
  const [plan, found] = await Promise.all([
    apiClient.get('/users/me/plan').then(r => r.data),
    apiDataClient.get('/usage/findings').then(r => r.data)
  ])
  const limit = plan.findings_per_month
  return {
    plan,
    used: found.used,
    limit,
    resetsAt: new Date(found.resets_at),
    // 'ok' | 'warn' (90 % and more) | 'full'; no limit - always 'ok'
    level: limit == null ? 'ok' : found.used >= limit ? 'full' : found.used >= limit * WARN_SHARE ? 'warn' : 'ok'
  }
}

// The month of the limit is counted in Moscow time (data findings_quota): the reset date in
// Moscow, otherwise a browser west of Moscow showed «до 31 октября» for midnight of 1 November
export function resetDate(date) {
  return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', timeZone: 'Europe/Moscow' })
}

export function formatCount(n) {
  return n == null ? '' : Number(n).toLocaleString('ru-RU')
}
